import { Link } from '@inertiajs/react'
import { FaHome, FaSearch, FaExclamationTriangle } from 'react-icons/fa'
import MainLayout from '@/Layout/MainLayout'

const NotFound = () => {
  return (
    <MainLayout>
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full bg-white rounded-2xl shadow-xl p-8 md:p-12 text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-red-100 p-4 rounded-full">
            <FaExclamationTriangle className="text-red-500 text-4xl" />
          </div>
        </div>
        
        <h1 className="text-4xl md:text-6xl font-bold text-gray-800 mb-4">
          Oops! Page Not Found
        </h1>
        
        <p className="text-lg text-gray-600 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        
        <div className="space-y-4">
          <Link 
            href="/"
            className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 w-full md:w-auto"
          >
            <FaHome className="mr-2" />
            Go Back Home
          </Link>
          
          {/* <div className="text-sm text-gray-500">
            <p className="mb-2">Here are some helpful links:</p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link href="/about" className="text-blue-600 hover:text-blue-800">
                About Us
              </Link>
              <Link href="/contact" className="text-blue-600 hover:text-blue-800">
                Contact
              </Link>
              <Link href="/faq" className="text-blue-600 hover:text-blue-800">
                FAQ
              </Link>
            </div>
          </div> */}
        </div>
        
        <div className="mt-12 p-4 bg-gray-50 rounded-lg">
          <h2 className="text-lg font-semibold text-gray-800 mb-2">
            Need Help?
          </h2>
          <p className="text-gray-600 mb-4">
            If you believe this is an error, please contact our support team.
          </p>
          <Link 
            href="/contact"
            className="inline-flex items-center text-blue-600 hover:text-blue-800"
          >
            <FaSearch className="mr-2" />
            Contact Support
          </Link>
        </div>
      </div>
    </div>
    </MainLayout>
  )
}

export default NotFound